import { render } from "./AIChatMessagesPage.vue?vue&type=template&id=e07d41c0&scoped=true"
import script from "./AIChatMessagesPage.vue?vue&type=script&lang=js"
export * from "./AIChatMessagesPage.vue?vue&type=script&lang=js"

import "./AIChatMessagesPage.vue?vue&type=style&index=0&id=e07d41c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e07d41c0"]])

export default __exports__